import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import ReportActions from '../../../report-actions';
import { EXPORT_CSV, EXPORT_EXCEL, EXPORT_PDF } from '../../../report-actions/constants';
import ReportFilters from '../../../report-filters';
import {
  DATE_RANGE_PROPS,
  ORDER_STATUS_PROPS,
  SAVED_ORDER_FILTER_PROPS,
  GROUP_ITEM_DEMAND_REPORT,
  SORT_ITEM_DEMAND_REPORT,
} from '../../../report-filters/report-paramter-input-properties';
import { buildDropdownOptions } from '../../../report-filters/filters/dropdown/helpers';
import { useAsyncSafeState } from 'ui-components/hooks/async-safe';
import { getFilterSets } from '../../../../../../../store/saved-filters-api';
import * as reportFilterConstants from '../../../report-filters/constants';
import { PARAMETER_NAME_SAVED_FILTER_ID } from '../../../report-filters/report-parameter-names';

const actions = [EXPORT_PDF, EXPORT_EXCEL, EXPORT_CSV];

const filtersProps = [ORDER_STATUS_PROPS, SAVED_ORDER_FILTER_PROPS, DATE_RANGE_PROPS, GROUP_ITEM_DEMAND_REPORT, SORT_ITEM_DEMAND_REPORT];

const ItemDemandSummary = () => {
  const [filterOptions, setFilterOptions] = useAsyncSafeState(
    useSelector((state) => buildDropdownOptions({ filtersProps, state }), shallowEqual),
  );
  const [shouldFetchFilters, setShouldFetchFilters] = useAsyncSafeState(true);
  useEffect(() => {
    if (shouldFetchFilters) {
      setShouldFetchFilters(false);
      getFilterSets().then((savedFilterSets) => {
        const activeFilters = Object.values(savedFilterSets).reduce((acc, filter) => {
          if (filter.active) {
            acc.push({
              ...filter,
              [PARAMETER_NAME_SAVED_FILTER_ID]: filter.orderFilterSetId,
            });
          }
          return acc;
        }, []);
        const combinedOptions = filterOptions.map((filterProp) => {
          if (filterProp.filterType === reportFilterConstants.SAVED_ORDER_FILTER) {
            return {
              ...filterProp,
              options: [...filterProp.options, ...activeFilters],
            };
          }
          return {
            ...filterProp,
          };
        });
        setFilterOptions(combinedOptions);
      });
    }
  }, [filterOptions, setFilterOptions, shouldFetchFilters, setShouldFetchFilters]);

  return (
    <>
      <ReportFilters filtersProps={filterOptions} />
      <ReportActions actions={actions} />
    </>
  );
};

export default ItemDemandSummary;
